<template>
  <div>
    <a-row>
      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="iotplt-descriptions"
        >
          <a-descriptions-item label="操作类型">
            {{ batchOperationRecordInfo.operation_type_display }}
          </a-descriptions-item>

          <a-descriptions-item label="操作批次">
            {{ batchOperationRecordInfo.operation_no }}
          </a-descriptions-item>

          <a-descriptions-item label="操作时间">
            {{ batchOperationRecordInfo.created_at }}
          </a-descriptions-item>

          <a-descriptions-item
            v-if="batchOperationRecordInfo.scheduled_execute_at"
            label="计划执行时间"
          >
            <a
              v-if="batchOperationRecordInfo.can_manage_schedule"
              href="javascript:;"
              @click="openScheduleModal"
            >{{ batchOperationRecordInfo.scheduled_execute_at }}</a>
            <span v-else>{{ batchOperationRecordInfo.scheduled_execute_at }}</span>
          </a-descriptions-item>

          <a-descriptions-item label="备注">
            <span class="iotplt-word-break-all">
              {{ batchOperationRecordInfo.remark }}
            </span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="iotplt-descriptions"
        >
          <a-descriptions-item label="操作方式">
            {{ batchOperationRecordInfo.operator_type_display }}
          </a-descriptions-item>

          <a-descriptions-item label="操作人">
            {{ batchOperationRecordInfo.operator_name }}
          </a-descriptions-item>

          <a-descriptions-item label="重跑次数">
            {{ batchOperationRecordInfo.run_times }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="8">
        <a-descriptions
          :column="1"
          class="iotplt-descriptions"
        >
          <a-descriptions-item label="卡号总数">
            {{ batchOperationRecordInfo.operation_count }}
          </a-descriptions-item>

          <a-descriptions-item label="操作失败数">
            {{ batchOperationRecordInfo.failure_count }}
          </a-descriptions-item>

          <a-descriptions-item label="操作成功数">
            {{ batchOperationRecordInfo.success_count }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>

    <manage-scheduled-execute-at
      :visible.sync="scheduleModalVisible"
      :record="scheduleRecord"
      @completed="handleScheduleCompleted"
    />
  </div>
</template>

<script>
import ManageScheduledExecuteAt from '@/views/batch_operation_records/ManageScheduledExecuteAt'

export default {
  name: 'BatchOperationDetailCommonInfo',
  components: { ManageScheduledExecuteAt },
  props: {
    batchOperationRecordInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      scheduleModalVisible: false
    }
  },
  computed: {
    scheduleRecord() {
      return {
        id: this.batchOperationRecordInfo.id,
        scheduled_execute_at: this.batchOperationRecordInfo.scheduled_execute_at
      }
    }
  },
  methods: {
    openScheduleModal() {
      this.scheduleModalVisible = true
    },
    handleScheduleCompleted() {
      this.$emit('schedule-updated')
    }
  }
}
</script>

